import type { EventEmitter } from '@stencil/core';
import { getExternalOriginSessionStorageValue, removeCTAActionSessionStorageValue } from '../../conversational-search-logic/storage-manager/storage-manager-helpers';
import { externalOriginEndOfConversationHandler } from '../../conversational-search-logic/utils/utils';
import type { labelProviderInterface } from '../../../../LabelProviderInterface';

let ctaIndentifier;
let ctaText;

const selectCorrectExitRoute = (
  conversationalSearchBrandUrl: string,
  chatVisibilityEventEmitter: EventEmitter<{ isChatVisible: boolean }>,
  country: string,
  language: string
) => {
    if (getExternalOriginSessionStorageValue()) {
      removeCTAActionSessionStorageValue();
      externalOriginEndOfConversationHandler(conversationalSearchBrandUrl, country, language);
    } else {
      chatVisibilityEventEmitter.emit({ isChatVisible: false });
    }
};

export const hideChatHandler = (
  conversationalSearchBrandUrl: string,
  chatVisibilityEventEmitter: EventEmitter<{ isChatVisible: boolean }>,
  country: string,
  language: string,
) => {
    selectCorrectExitRoute(
      conversationalSearchBrandUrl,
      chatVisibilityEventEmitter,
      country,
      language
    );
};

export const setButtonText = (
  labelProvider: labelProviderInterface,
  updateCta: (ctaText: string, ctaIndentifier: string) => void,
  isCtaActivated: boolean,
) => {
    const buttonTextFallbacks = ['Back', 'Back to Search', 'Back to Homepage'];
    const buttonText = [
      labelProvider('conversational.search.navigator.back.general', buttonTextFallbacks[0]),
      labelProvider('conversational.search.navigator.back.to.srp', buttonTextFallbacks[1]),
      labelProvider('conversational.search.navigator.back.to.homepage', buttonTextFallbacks[2]),
    ];

    const externalOriginAction = !isCtaActivated && getExternalOriginSessionStorageValue();

    // Not in media utils as it is very GenAI specific case
    const isMediumLargeDesktop = window.innerWidth <= 1280;

    if (isMediumLargeDesktop) {
      ctaText = buttonText[0];
      ctaIndentifier = buttonTextFallbacks[0];
    } else if (externalOriginAction) {
      ctaText = buttonText[2];
      ctaIndentifier = 'Back to Homepage';
    } else {
      ctaText = buttonText[1];
      ctaIndentifier = 'Back to Search';
    }

    updateCta(ctaText, ctaIndentifier);
};
